import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'

interface EditFooterProps {
  onCancel: () => void
  onSave?: () => void
  saveType?: 'button' | 'submit'
  disabled?: boolean
}

export function EditFooter({
  onCancel,
  onSave,
  saveType = 'button',
  disabled,
}: EditFooterProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-end gap-2.5 px-2.5 pt-1.25 pb-2.5">
      <div className="h-px w-full bg-gray-200" />
      <div className="flex items-center gap-2.5">
        <Button
          type="button"
          variant="outline"
          size="xs"
          pressEffect
          className="px-3.75"
          onClick={onCancel}
        >
          {t('shipmentCard.cancel')}
        </Button>
        <Button
          type={saveType}
          size="xs"
          pressEffect
          className="px-3.75"
          onClick={onSave}
          disabled={disabled}
        >
          {t('shipmentCard.saveChanges')}
        </Button>
      </div>
    </div>
  )
}
